import React from 'react';
import { DropdownMenuHeader, DropdownMenuItem } from '@bibliocommons/base-dropdown';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { SHELF_NAMES } from '../../../../constants/ShelfConstants';
import BatchActionLink from '../../../shared/BatchActions/BatchActionLink';

// TODO: convert this to a proper React component when we update to React 16.
// In React 15 component render methods are not allowed to return arrays, so this has to be a regular function.
export default function renderAddToShelfBatchActions({ items, handleBatchAddToShelf }) {
  const addToShelfItems = items.filter((item) => item.get('actions').includes('addToShelf'));
  const moveMenuHeader = (
    <DropdownMenuHeader key="shelf-batch-actions-header">
      <FormattedHTMLMessage id="add_to_shelf_with_count" values={{ count: addToShelfItems.size }} />
    </DropdownMenuHeader>
  );

  const shelfNames = [
    SHELF_NAMES.IN_PROGRESS,
    SHELF_NAMES.FOR_LATER,
    SHELF_NAMES.COMPLETED
  ];

  const moveMenuItems = shelfNames.map(shelfName => (
    <DropdownMenuItem key={`add-to-shelf-batch-actions-${shelfName}`}>
      <BatchActionLink
        disabled={addToShelfItems.size === 0}
        href={`#add-to-shelf-batch-actions-${shelfName}`}
        handleClick={() => handleBatchAddToShelf(addToShelfItems, shelfName)}>
        <FormattedMessage id={`label_shelf_${shelfName}`} />
      </BatchActionLink>
    </DropdownMenuItem>
  ));

  return [
    moveMenuHeader,
    ...moveMenuItems
  ];
}



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/AddToShelfBatchActions/AddToShelfBatchActions.jsx